export const buildSmsCopyActivityPayload = ({ familyId, onboardingCardId } = {}) => ({
    familyId: String(familyId || '').trim(),
    onboardingCardId: String(onboardingCardId || '').trim(),
})

export const isSmsTemplateExcludedCard = (card = {}) => {
    const description = String(card?.todoDescription || '').trim().toLowerCase()
    const list = String(card?.whichList || '').trim().toLowerCase()

    return (
        description === 'reassign' ||
        description === 'old student' ||
        list === 'orange' ||
        list === 'blue'
    )
}

export const copySmsTemplateAndRecordAttempt = async ({
    smsTemplate,
    familyId,
    onboardingCardId,
    writeText,
    recordAttempt,
}) => {
    if (typeof writeText !== 'function') {
        throw new Error('Clipboard writing is unavailable.')
    }
    if (typeof recordAttempt !== 'function') {
        throw new Error('SMS response tracking is unavailable.')
    }

    await writeText(smsTemplate)

    try {
        return await recordAttempt(
            buildSmsCopyActivityPayload({ familyId, onboardingCardId })
        )
    } catch (error) {
        error.smsTemplateWasCopied = true
        throw error
    }
}
